import React from 'react';
import {useDispatch, useSelector} from 'react-redux';
import { setActive } from '../store/DocumentStore'; 
import config from '../config';
import Menu from './Menu';
import './Documents.css';

const Documents = () => {
    const dispatch = useDispatch();
    const documents = useSelector(state => state.documentState.documents);
    const activeDocument = useSelector(state => state.documentState.activeDocument);

    const setActiveDocument = document => {
        dispatch(setActive(document));
    };

    return(
        <div className="App">
            <Menu />
            <div className='documents'>
                <div className='documents-container'>
                    {documents && documents.map(document => {
                        return(
                            <div key={document.id} onClick={() => setActiveDocument(document)} className={`document ${activeDocument && document.id === activeDocument.id ? 'active' : ''}`}>
                                {document.name}
                            </div>
                        );
                    })}
                </div>
                {activeDocument &&
                <div className='preview'>
                    <embed key={`${config.server}${activeDocument.path}`} src={`${config.server}${activeDocument.path}`} alt="pdf" pluginspage="http://www.adobe.com/products/acrobat/readstep2.html" />
                </div>
                }
            </div>
        </div>
    );
};

export default Documents;